/** HTTP header key names used across interceptors — mirrors Consumer's network/HeaderConstants.ts. */
export const HeaderConstant = {
  HEADER_CONTENT_TYPE: 'content-type',
  CONTENT_TYPE_JSON: 'application/json',
  HEADER_AUTHORIZATION: 'Authorization',
  HEADER_USER_X_API_KEY: 'x-api-key',
  HEADER_SUBSCRIBER_ID: 'subscriberId',
  HEADER_ENCRYPTED_SUBSCRIBER_ID: 'encryptedsubscriberId',
  HEADER_MOBILE_NUMBER: 'mobileNo',
  HEADER_UNIQUE_ID: 'uniqueId',
} as const;
